import { render, staticRenderFns } from "./AS_Newsletter.vue?vue&type=template&id=697789ee&scoped=true&"
import script from "./AS_Newsletter.vue?vue&type=script&lang=js&"
export * from "./AS_Newsletter.vue?vue&type=script&lang=js&"
import style0 from "./AS_Newsletter.vue?vue&type=style&index=0&id=697789ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697789ee",
  null
  
)

export default component.exports